/**
 * True when /start was opened from a link that logs someone in by itself:
 * a caregiver portal link (?mobile=&pin=) or a QE link (?qe=true&id=).
 * These links name the person to sign in, so they must replace any session
 * already stored in the browser instead of being skipped by it.
 */
export const hasAutoLoginParams = (search: string | URLSearchParams): boolean => {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const hasPortalPin = !!params.get('mobile')?.replace(/\D/g, '') && !!params.get('pin')?.trim();
  const hasQeLogin = params.get('qe') === 'true' && !!params.get('id')?.trim();
  return hasPortalPin || hasQeLogin;
};

// Pages a login link may send the caregiver to via ?next=; anything else falls back to the form.
const LINK_DESTINATIONS: Record<string, string> = {
  availability: '/availability',
};

/** Where a /start link asks to land after login, e.g. ?next=availability → /availability. */
export const getLinkDestination = (search: string | URLSearchParams): string | null => {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const next = params.get('next')?.trim().toLowerCase();
  // Own keys only: next=constructor / __proto__ must not resolve to inherited Object members.
  return next && Object.prototype.hasOwnProperty.call(LINK_DESTINATIONS, next) ? LINK_DESTINATIONS[next] : null;
};

/** Language a link asks for via ?lang=en|es, so caregivers land in their own language. */
export const getLinkLanguage = (search: string | URLSearchParams): 'en' | 'es' | null => {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const lang = params.get('lang')?.trim().toLowerCase();
  return lang === 'en' || lang === 'es' ? lang : null;
};
